<template>
  <div></div>
</template>

<script>
export default {
  name: "LabSideRight",
};
</script>